import * as cons from './constants';
import { requestReducerMaker, initialState } from '../helper'

export const getAllCourseClass = (state = initialState, action) => requestReducerMaker(cons.GET_ALL_COURSE_CLASS, state, action);
export const getCourseClass = (state = initialState, action) => requestReducerMaker(cons.GET_COURSE_CLASS, state, action);
